/*eslint-disable*/
import { NavBar } from 'components/NavBar/NavBar'
import { IDBMachineUserTask, IUtilization } from 'features/dashboard/types'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { Animation, Button, ColoredDot, Flex, H1, H1WithBack, HR, NotAvailable, NotAvailableContainer, PageWrapper, Separator } from 'styling/GlobalStyles'
import { DBTaskStatus, DBTaskTimelineItem, DBTimelineTitle } from '../DashboardTasks/DBTasks.styled'
import { ImagesSlider } from 'components/ImagesSlider/ImagesSlider'
import { getSingleDBMachine } from 'features/dashboard/dbMachinesSlice'
import { DBMachineDetail, DBMachineFuelLevelContainer, DBIndicator, DBMachineGraphBox, DBMachineInfoSection, DBMachineMap, DBMachineRightSide, DBMachineStatusIcon } from './DBMachines.styled'
import { machineryStatusesData } from '../dashboardData'
import { formatDate, formatDateForDisplay, getTime } from 'utils/helpers'
import { TasksTabs, TasksTabsContainer } from 'pages/TaskTemplates/DragComponents/Tasks.styled'
import { Chart } from 'components/Charts/Charts'
import Chevron from 'assets/icons/Chevron'
import { Wrapper } from '@googlemaps/react-wrapper'
import { PowerIcon } from 'assets/icons/PowerIcon'
import { Modal } from 'components/Modal/Modal'
import { TasksModal } from './TasksModal'
import machineMapIcon from '../../../assets/images/machineMapIcon.png'
import { BodyText, OtherText, TitleText } from 'styling/Typography'

interface ITimelineItem {
    data: IDBMachineUserTask
    margin?: boolean
    openDefault?: boolean
}

export const Utilization = ({ notAvailable, ut }: { notAvailable: boolean, ut?: IUtilization }) => {
    const [open, setOpen] = useState(true)
    const [activeTab, setActiveTab] = useState('Today')
    const fuelData = useSelector((state: RootState) => state.dbMachines?.singleDBMachine?.develonVehicle)?.fuelData
    const utilization = ut || useSelector((state: RootState) => state.dbMachines?.singleDBMachine?.develonVehicle)?.utilization
    const dispatch = useDispatch<AppDispatch>()
    const { id } = useParams()
    useEffect(() => {
        if (id) {
            dispatch(getSingleDBMachine({ id, utilizationInfoDateSpanType: activeTab == 'Today' ? 1 : activeTab == '1 Week' ? 2 : 3 }))
        }
    }, [id, activeTab])

    return (
        <DBMachineInfoSection open={open}>
            {notAvailable && <NotAvailable style={{ borderRadius: '12.5px' }}>
                <OtherText>Not Available</OtherText>
            </NotAvailable>}
            <Flex column gap='8px' width='100%' alignStart>
                <Flex width='100%' between center onClick={() => setOpen(p => !p)} >
                    <TitleText weight='bold'  >Utilization</TitleText>
                    <Chevron open={open} />
                </Flex>
                {open && <Flex column width='100%' >
                    <Flex m='1rem 0' width='100%' between >
                        <TasksTabsContainer noMargin >
                            <TasksTabs adaptWidth active={activeTab == 'Today'} onClick={() => setActiveTab('Today')} >
                                Today
                            </TasksTabs>
                            <TasksTabs adaptWidth active={activeTab == '1 Week'} onClick={() => setActiveTab('1 Week')} >
                                1 Week
                            </TasksTabs>
                            <TasksTabs adaptWidth active={activeTab == '2 Weeks'} onClick={() => setActiveTab('2 Weeks')} >
                                2 Weeks
                            </TasksTabs>
                        </TasksTabsContainer>
                        {/* <Flex gap='1rem' center>
                            <P>05.05.2020.</P>
                            <BoxDateInput label='' date={new Date()} />
                        </Flex> */}
                    </Flex>
                    <Flex width='100%'>
                        <Flex width='100%' gap='2rem'  >
                            <DBMachineGraphBox>
                                <Flex width='100%' between >
                                    <OtherText weight='bold'>Operation Hour</OtherText>
                                    <OtherText weight='bold'>{utilization?.totalHours?.toFixed(2)} l</OtherText>
                                </Flex>
                                <HR mt='1' />
                                <OtherText style={{ margin: '1rem 0' }} >Utilization Rate</OtherText>
                                <Chart notAvailable={!utilization?.utilizationRatePercent} fontSize={12} customLabel={utilization?.utilizationRatePercent + '%'} color={'#00B04C'} data={[{ name: 'Working', value: notAvailable ? 5 : utilization?.operatingHours }, { name: 'Idle', value: notAvailable ? 23 : utilization?.idleHours }]} chartColors={['#00B04C', '#DFDEE1']} modifiedData={[{ name: 'Working', value: notAvailable ? 5 : utilization?.operatingHours }, { name: 'Idle', value: notAvailable ? 23 : utilization?.idleHours }]} />
                                <Flex width='100%' between >
                                    <Flex mt='1rem' gap='1rem' center >
                                        <ColoredDot color='#00B04C' />
                                        <OtherText>Working</OtherText>
                                    </Flex>
                                    <OtherText>{utilization?.operatingHours ?? '/'} h</OtherText>
                                </Flex>
                                <Flex mt='15px' width='100%' between >
                                    <Flex gap='1rem' center >
                                        <ColoredDot color='#DFDEE1' />
                                        <OtherText>Idle</OtherText>
                                    </Flex>
                                    <OtherText>{utilization?.idleHours ?? '/'} h</OtherText>
                                </Flex>
                            </DBMachineGraphBox>
                            <DBMachineGraphBox>
                                <Flex width='100%' between >
                                    <OtherText weight='bold'>Fuel Used</OtherText>
                                    <OtherText weight='bold'>{fuelData?.totalAmount} l</OtherText>
                                </Flex>
                                <HR mt='1' />
                                <BodyText weight='bold' style={{ margin: '1rem 0' }} >Utilization Rate</BodyText>
                                <Chart notAvailable={!fuelData?.amountPerHour} fontSize={12} customLabel={notAvailable ? '100%' : (fuelData?.amountPerHour + ' L/H')} color={'#ff9900'} data={[{ name: 'Working', value: notAvailable ? 5 : fuelData?.totalAmountForOperatingHours }, { name: 'Idle', value: notAvailable ? fuelData?.totalAmountForIdleHours : 23 }]} chartColors={['#FF9900', '#DFDEE1']} modifiedData={[{ name: 'Working', value: notAvailable ? 5 : fuelData?.totalAmountForOperatingHours }, { name: 'Idle', value: notAvailable ? fuelData?.totalAmountForIdleHours : 23 }]} />
                                <Flex width='100%' between >
                                    <Flex mt='1rem' gap='1rem' center >
                                        <ColoredDot color='#FF9900' />
                                        <OtherText>Working</OtherText>
                                    </Flex>
                                    <OtherText>{fuelData?.totalAmountForOperatingHours ?? '/'} h</OtherText>
                                </Flex>
                                <Flex mt='15px' width='100%' between >
                                    <Flex gap='1rem' center >
                                        <ColoredDot color='#DFDEE1' />
                                        <OtherText>Idle</OtherText>
                                    </Flex>
                                    <OtherText>{fuelData?.totalAmountForIdleHours ?? '/'} h</OtherText>
                                </Flex>
                            </DBMachineGraphBox>
                        </Flex>
                    </Flex>
                </Flex>}
            </Flex>
        </DBMachineInfoSection>
    )
}

const GeneralInfo = () => {
    const [open, setOpen] = useState(false)
    const { singleDBMachine } = useSelector((state: RootState) => state.dbMachines)

    return (
        <DBMachineInfoSection open={open}>
            <Flex column gap='8px' width='100%' alignStart>
                <Flex width='100%' between center onClick={() => setOpen(p => !p)} >
                    <TitleText weight='bold'>General Info</TitleText>
                    <Chevron open={open} />
                </Flex>
                {open && (
                    <Flex width='100%' column>
                        <Flex width='100%' gap='2rem'>
                            <DBMachineDetail bold width='30%'>Machine Name</DBMachineDetail>
                            <DBMachineDetail width='70%'>{singleDBMachine?.name}</DBMachineDetail>
                        </Flex>
                        <Flex width='100%' gap='2rem'>
                            <DBMachineDetail bold width='30%'>Category</DBMachineDetail>
                            <DBMachineDetail width='70%'>
                                {singleDBMachine?.category.name}
                            </DBMachineDetail>
                        </Flex>
                        <Flex width='100%' gap='2rem'>
                            <DBMachineDetail bold width='30%'>Model</DBMachineDetail>
                            <DBMachineDetail width='70%'>
                                {singleDBMachine?.model.model}
                            </DBMachineDetail>
                        </Flex>
                        <Flex width='100%' gap='2rem'>
                            <DBMachineDetail bold width='30%'>Task</DBMachineDetail>
                            <DBMachineDetail width='70%'>
                                {singleDBMachine?.currentTask?.name || '/'}
                            </DBMachineDetail>
                        </Flex>
                        <Flex width='100%' gap='2rem'>
                            <DBMachineDetail bold width='30%'>Purchase date</DBMachineDetail>
                            <DBMachineDetail width='70%'>
                                {singleDBMachine?.purchaseDate ? formatDate(new Date(singleDBMachine?.purchaseDate)) : '/'}
                            </DBMachineDetail>
                        </Flex>
                        <Flex width='100%' gap='2rem'>
                            <DBMachineDetail bold width='30%'>Price</DBMachineDetail>
                            <DBMachineDetail width='70%'>
                                {singleDBMachine?.price}
                            </DBMachineDetail>
                        </Flex>
                        <Flex width='100%' gap='2rem'>
                            <DBMachineDetail bold width='30%'>Total working hours</DBMachineDetail>
                            <DBMachineDetail width='70%'>
                                {singleDBMachine?.develonVehicle ? singleDBMachine?.develonVehicle.totalWorkingHours : '/'}
                            </DBMachineDetail>
                        </Flex>
                    </Flex>
                )}
            </Flex>
        </DBMachineInfoSection>
    )
}

const TimelineItem = ({ data, margin, openDefault }: ITimelineItem) => {
    const [open, setOpen] = useState(openDefault)
    return (
        <DBTaskTimelineItem margin={margin} onClick={() => setOpen((prev) => !prev)}>
            <DBTimelineTitle status={1}>
                <Flex column gap='8px' width='100%' alignStart>
                    <Flex width='100%' between center>
                        <BodyText weight='bold'>{data?.name}</BodyText>
                        <OtherText>{formatDateForDisplay(data?.date ?? '/')}</OtherText>
                    </Flex>
                    {open && (
                        <>
                            <Separator />
                            <Flex width='100%' between>
                                <OtherText>Location: </OtherText>
                                <OtherText>{data?.location?.name}</OtherText>
                            </Flex>
                            <Flex width='100%' between>
                                <OtherText>Actual Duration: </OtherText>
                                <OtherText>{data?.durationInMinutes ? getTime(data?.durationInMinutes) : '-'}</OtherText>
                            </Flex>
                            <Flex width='100%' between>
                                <OtherText>Employee: </OtherText>
                                <OtherText>{data?.user.firstName + ' ' + data?.user.lastName}</OtherText>
                            </Flex>
                        </>
                    )}
                </Flex>
            </DBTimelineTitle>
        </DBTaskTimelineItem>
    )
}

export const DBSingleMachine = () => {
    const { id } = useParams()
    const [imagesModal, setImagesModal] = useState({ open: false, images: [] })
    const [tasksModal, setTasksModal] = useState({ open: false })
    const { singleDBMachine } = useSelector((state: RootState) => state.dbMachines)
    const mapRef = useRef(null)
    const [map, setMap] = useState<any>()

    useEffect(() => {
        if (map && singleDBMachine?.develonVehicle) {
            const content = document.createElement('div')
            const imageContent = document.createElement('img')
            const text = document.createElement('p')
            text.innerText = 'ds'
            content.className = 'marker'
            imageContent.className = 'marker-image'
            imageContent.src = machineMapIcon

            content.appendChild(imageContent)
            content.appendChild(text)

            const marker = new google.maps.marker.AdvancedMarkerElement({
                position: { lat: singleDBMachine.develonVehicle.latitude, lng: singleDBMachine.develonVehicle.longitude },
                map,
                content,
            })
        }

    }, [singleDBMachine])



    const mapOptions = {
        gestureHandling: 'greedy',
        zoom: 5,
        mapId: '4504f8b37365c3d0',
        center: {
            lat: 0,
            lng: 0,
        },
        disableDefaultUI: true,
        mapTypeId: 'satellite' as google.maps.MapTypeId,
        styles: [
            {
                featureType: 'all',
                elementType: 'labels',
                stylers: [
                    { visibility: 'off' }
                ]
            }
        ]
    }

    useEffect(() => {
        if (mapRef.current) {
            setMap(new window.google.maps.Map(mapRef.current, mapOptions))
        }
    }, [mapRef.current])


    const Status = () => {
        const status = machineryStatusesData.find((s) => s.id == singleDBMachine?.status)
        return (
            <DBTaskStatus status={singleDBMachine?.status}>
                <DBMachineStatusIcon color={status?.iconColor}>{status?.icon}</DBMachineStatusIcon>
                <Flex gap='5px'>
                    <TitleText weight='bold' >Status: </TitleText>
                    <TitleText>{status?.name}</TitleText>
                </Flex>
            </DBTaskStatus>
        )
    }

    const Power = () => {
        return (
            <DBTaskStatus status={singleDBMachine?.status}>
                <DBMachineStatusIcon color={singleDBMachine?.develonVehicle?.isRunning ? "#00B04C" : '#ff8899'}><PowerIcon /></DBMachineStatusIcon>
                <Flex gap='5px'>
                    <TitleText weight='bold' >Engine: </TitleText>
                    <TitleText>{singleDBMachine?.develonVehicle ? (singleDBMachine.develonVehicle.isRunning ? 'On' : 'Off') : '/'}</TitleText>
                </Flex>
            </DBTaskStatus>
        )
    }


    return (
        <>
            <NavBar />
            <Animation>
                <PageWrapper noFooter>
                    <Flex width='100%' between>
                        <H1WithBack arrow title={singleDBMachine?.name} />
                        <Flex gap='2rem' >
                            <Status />
                            <Power />
                        </Flex>
                    </Flex>
                    <Flex width='100%' gap='2rem' mt='30'>
                        <Flex column gap='1rem' width='60%'>
                            <Utilization notAvailable={!singleDBMachine?.develonVehicle} />
                            <GeneralInfo />
                        </Flex>
                        <DBMachineRightSide>
                            <Flex mb='10' width='100%' between >
                                <BodyText weight='bold'>Location</BodyText>
                                <BodyText weight='bold' color='#ff9900' >{singleDBMachine?.currentTask ? singleDBMachine.currentTask.location?.name : 'Not Available'}</BodyText>
                            </Flex>
                            <NotAvailableContainer style={{ borderRadius: 15 }}>
                                {!singleDBMachine?.develonVehicle && <NotAvailable><OtherText style={{ color: "#fff" }} >Not Available</OtherText></NotAvailable>}
                                <Wrapper apiKey={process.env.REACT_APP_GOOGLE_KEY} version='beta' libraries={['marker']}>
                                    <DBMachineMap ref={mapRef} />
                                </Wrapper>
                            </NotAvailableContainer>
                            <BodyText weight='bold'>Fuel Level</BodyText>
                            <NotAvailableContainer>
                                {!singleDBMachine?.develonVehicle && <NotAvailable><OtherText>Not Available</OtherText></NotAvailable>}
                                <DBMachineFuelLevelContainer>
                                    <DBIndicator level={singleDBMachine?.develonVehicle?.fuelRemainingPercent ?? 60} />
                                    <H1 color='#ff9900' >{singleDBMachine?.develonVehicle?.fuelRemainingPercent ?? 60}%</H1>
                                </DBMachineFuelLevelContainer>
                            </NotAvailableContainer>
                            <BodyText weight='bold' >Last Task</BodyText>
                            {
                                singleDBMachine?.lastTask ? <>
                                    <TimelineItem openDefault margin data={singleDBMachine?.lastTask} />
                                    <Button onClick={() => setTasksModal({ open: true })} maxWidth orange >View Tasks Timeline</Button>
                                </> : <Flex width='100%' center justcenter mt='20'><OtherText>There were no tasks for this machine yet</OtherText></Flex>
                            }

                        </DBMachineRightSide>
                    </Flex>
                </PageWrapper>
            </Animation>
            {imagesModal.open && (
                <ImagesSlider images={imagesModal.images} setImagesModal={setImagesModal} />
            )}
            {
                tasksModal.open && <Modal black>
                    <TasksModal setTasksModal={setTasksModal} id={id} />
                </Modal>
            }
        </>
    )
}
